module.exports = __webpack_public_path__ + "static/media/24UHCHR20.a9a2ebec.jpg";